import React, { useEffect, useState, useCallback, useRef } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import './App.css';
import './custom.css';

import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  NestedCard,
  Cards,
  AddCard,
  ModalPopup,
  SearchTrello,
  Popup,
} from './component';
import { useNavigate, useLocation } from 'react-router-dom';
import { UTILS } from './constants';
import { useDispatch } from 'react-redux';
import NotificationTrello from './component/notification';
import Select2 from 'react-select2-wrapper';
import 'select2/dist/css/select2.min.css';
import _ from 'lodash';
import './responsive.css';
import { UserProfile } from './component/userProfile';
import { useHorizontalScroll } from './utils/function';
import { io } from 'socket.io-client';
import { UpdateDepartment } from './redux/featuers/sliceDept';
import ShimmerBoardList from './component/shimmerEffect';
import ShimmerSearch from './component/shimmerEffect/shimmersearch';

const SOCKET_SERVER_URL = 'https://trello-node-app-5a0de59e2e86.herokuapp.com/';

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [socket, setSocket] = useState(null);
  const departmentIdRef = useRef(null);
  const dispatchItem = useDispatch();

  const [board, setBoard] = useState([]);
  const [teams, setTeam] = useState([]);
  const [backgroundImage, setBackgroundImage] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [departmentId, setDepartmentID] = useState(2);
  const [cardDetail, setCardDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(true);
  const [error, setError] = useState(null);
  const [client, setClient] = useState([]);
  const [searchCards, setSearchCards] = useState([]);
  const [showModalPopup, setShowModalPopup] = useState(false);
  const [colors, setColors] = useState([]);
  const [selectTeamId, setSelectTeamId] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [toggleMobile, settoggleMobile] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(0);
  const [paginationOffsets, setPaginationOffsets] = useState({}); // To track pagination offsets
  const [userDetails, setuserDetails] = useState({}); // To track pagination offsets
  let [notificationCount, setNotificationCount] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [trashUpdate, setTrashUpdate] = useState(false);
  const [firstChange, setFirstChange] = useState(true);
  const previousScrollTop = useRef(0);
  const lastScrollTop = useRef(0);
  const FirstLoad = useRef(0);
  const url = UTILS.API_url;

  const scrollRef = useHorizontalScroll();

  const searchParams = new URLSearchParams(location.search);
  const paramValue = searchParams.get('code');
  let [getparams, setGetParams] = useState(paramValue);

  console.log(selectedDepartment, 'selectedDepartment');

  const HandleTeamChange = async (e) => {
    // Prevent execution on load
    const teamId = e.target.value; // Get the new team ID
    if (teamId === '' || teamId === null) return;

    // console.log('Selected_teamId', e.target.value);

    setSelectTeamId(teamId); // Update the selected team ID
    localStorage.setItem('team_key', teamId);
    const fetchCards = async () => {
      try {
        const randomString = Math.random().toString(36).substring(2, 5);
        var _URL = `${url}board/v1/board-lists?request=2&cache=${randomString}&department_id=${Number(
          departmentId
        )}&team_key=${teamId}`;

        const response = await axios.get(_URL, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          },
        });
        setBoard(response.data.board_lists);
        setClient(response.data.clients);
        setColors(response?.data?.colors);
        setTeam(response?.data?.teams);
        setDepartments(response.data.departments);
        setNotificationCount(response.data.unread_notifications_count);
        setPaginationOffsets(
          response.data.board_lists.reduce((acc, col) => {
            acc[col.id] = 20;
            return acc;
          }, {})
        );
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    setLoading(true);
    await fetchCards();
    setLoading(false);
  };

  useEffect(() => {
    const socketInstance = io(SOCKET_SERVER_URL, {
      transports: ['websocket'],
    });

    socketInstance.on('connect', () => {
      // console.log('Connected to socket');
    });

    socketInstance.on('connect_error', function () {
      // console.log('Connection Failed');
    });

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!socket) return;

    socket.on('OnCardDragEvent', (data) => {
      console.log('OnCardDragEvent', data);

      OnCardDragEvent(data, selectedDepartment);
    });
  }, [socket]);

  const fetchCardsForPopUp = async () => {
    if (selectTeamId === null || 0) return;
    try {
      let userData = JSON.parse(localStorage.getItem('userDetails'));
      const randomString = Math.random().toString(36).substring(2, 5);
      var _URL = `${url}board/v1/board-lists?request=4&cache=${randomString}&department_id=${Number(
        departmentId
      )}&team_key=${
        userData.type === 'executive' || userData.type === 'third-party-user'|| userData.type === 'ppc'
          ? selectTeamId
          : userData.team_key
      }`;

      const response = await axios.get(_URL, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
        },
      });
      setBoard(response.data.board_lists);
      setClient(response.data.clients);
      setColors(response?.data?.colors);
      setTeam(response?.data?.teams);
      setDepartments(response.data.departments);
      let data = response?.data?.departments.filter(
        (item) => item.id == response?.data?.default_department_id
      );
      console.log('data', data);

      setBackgroundImage(`url(${data[0]?.background_image})`);
      fetchDepartment(
        departmentId ? departmentId : response.data.default_department_id
      );
      setNotificationCount(response.data.unread_notifications_count);
      setPaginationOffsets(
        response.data.board_lists.reduce((acc, col) => {
          acc[col.id] = 20; // Initialize with first 10 items
          return acc;
        }, {})
      );
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  const initializeData = async (departmentId) => {
    const searchParams = new URLSearchParams(location.search);
    const loginParam = searchParams.get('login');
    if (loginParam) localStorage.setItem('trelloToken', loginParam);
    const trelloToken = localStorage.getItem('trelloToken');
    let token = loginParam || trelloToken;
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const response = await axios
          .get(UTILS.API_url + 'user', {
            headers: {
              Authorization: `Bearer ${
                token || localStorage.getItem('trelloToken')
              } `,
            },
          })
          .then((response) => {
            return response;
          });

        setuserDetails(response.data);
        // setSelectTeamId(
        //   response.data?.team_key ? response.data?.team_key : null
        // );

        const username = response.data.email;

        localStorage.setItem('userDetails', JSON.stringify(response.data));
        return response.data;
      } catch (error) {
        window.location.href = UTILS.Base_url + 'dashboard';
        return false;
      }
    };

    const fetchCardsstart = async () => {
      try {
        let userData = JSON.parse(localStorage.getItem('userDetails'));

        const randomString = Math.random().toString(36).substring(2, 5);
        const _URL = `${url}board/v1/board-lists?request=3&cache=${randomString}&department_id=${Number(
          departmentId
        )}&team_key=${
          userData.type === 'executive' || userData.type === 'third-party-user'|| userData.type === 'ppc'
            ? selectTeamId
            : userData.team_key
        }`;

        const response = await axios
          .get(_URL, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
            },
          })
          .then((response) => {
            if (response) {
              SearchCard(departmentId);
              setIsSearching(false);
              setLoading(false);
            }
            return response;
          });

        departmentIdRef.current =
          departmentIdRef.current == null
            ? parseInt(response.data.departments[0].id)
            : departmentIdRef.current;

        setBoard(response.data.board_lists);
        setClient(response.data.clients);
        setColors(response?.data?.colors);
        setTeam(response?.data?.teams);
        localStorage.setItem('departmentIdds', response.data.departments[0].id);

        setDepartments(response?.data?.departments);

        setNotificationCount(response.data.unread_notifications_count);
        setPaginationOffsets(
          response.data.board_lists.reduce((acc, col) => {
            acc[col.id] = 20; // Initialize with first 10 items
            return acc;
          }, {})
        );

        let data = response?.data?.departments.filter(
          (item) => item.id == response?.data?.default_department_id
        );
        setBackgroundImage(`url(${data[0]?.background_image})`);
        fetchDepartment(
          departmentId ? departmentId : response.data.default_department_id
        );
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    // Fetch user data first
    let userData = await fetchUserData();

    if (userData) {
      await fetchCardsstart();
    } else {
      setShowModalPopup(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    initializeData(departmentId);
  }, []);

  // Ensure useEffect depends on both departmentId and selectTeamId
  const SearchCard = async (department_id) => {
    let userData = JSON.parse(localStorage.getItem('userDetails'));
    const randomString = Math.random().toString(36).substring(2, 5);
    var _URL = `${url}board/v1/board-lists/search?cache=${randomString}&department_id=${Number(
      department_id
    )}&team_key=${
      userData.type === 'executive' || userData.type === 'third-party-user'|| userData.type === 'ppc'
        ? selectTeamId
        : userData.team_key
    }`;
    const response = await axios.get(_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
      },
    });

    setSearchCards(response?.data?.cards);
  };
  const fetchCards = async () => {
    if (selectTeamId === null || 0) return;
    try {
      let userData = JSON.parse(localStorage.getItem('userDetails'));
      const randomString = Math.random().toString(36).substring(2, 5);
      var _URL = `${url}board/v1/board-lists?request=4&cache=${randomString}&department_id=${Number(
        departmentId
      )}&team_key=${
        userData.type === 'executive' || userData.type === 'third-party-user'|| userData.type === 'ppc'
          ? selectTeamId
          : userData.team_key
      }`;

      const response = await axios.get(_URL, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
        },
      });
      setBoard(response.data.board_lists);
      setClient(response.data.clients);
      setColors(response?.data?.colors);
      setTeam(response?.data?.teams);
      setDepartments(response.data.departments);
      let data = response?.data?.departments.filter(
        (item) => item.id == response?.data?.default_department_id
      );
      console.log('data', data);

      setBackgroundImage(`url(${data[0]?.background_image})`);
      fetchDepartment(
        departmentId ? departmentId : response.data.default_department_id
      );
      setNotificationCount(response.data.unread_notifications_count);
      setPaginationOffsets(
        response.data.board_lists.reduce((acc, col) => {
          acc[col.id] = 20; // Initialize with first 10 items
          return acc;
        }, {})
      );
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  const EmitDrag = () => {
    if (!socket) return;
    console.log('emit heppen', selectedDepartment);

    socket.emit('OnCardDragEnd', { departmentId: selectedDepartment });
  };

  const OnCardDragEvent = async (dragDataEvent, selectedDepartment) => {
    console.log(
      dragDataEvent.departmentId,
      'dragDataEvent.departmentId',
      selectedDepartment
    );

    if (dragDataEvent.departmentId === selectedDepartment) {
      await fetchCardsstart(dragDataEvent.departmentId);
    }
  };

  const fetchCardsstart = async (deptId) => {
    try {
      let userData = JSON.parse(localStorage.getItem('userDetails'));
      const randomString = Math.random().toString(36).substring(2, 5);
      const _URL = `${url}board/v1/board-lists?request=1&cache=${randomString}&department_id=${Number(
        deptId
      )}&team_key=${
        userData.type === 'executive' || userData.type === 'third-party-user'|| userData.type === 'ppc'
          ? selectTeamId
          : userData.team_key
      }`;

      const response = await axios.get(_URL, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
        },
      });

      setBoard(response.data.board_lists);
      setClient(response.data.clients);
      setColors(response?.data?.colors);
      setTeam(response?.data?.teams);
      localStorage.setItem('departmentIdds', response.data.departments[0].id);

      setDepartments(response?.data?.departments);

      setNotificationCount(response.data.unread_notifications_count);
      setPaginationOffsets(
        response.data.board_lists.reduce((acc, col) => {
          acc[col.id] = 20; // Initialize with first 10 items
          return acc;
        }, {})
      );

      let data = response?.data?.departments.filter(
        (item) => item.id == response?.data?.default_department_id
      );

      setBackgroundImage(`url(${data[0]?.background_image})`);
      fetchDepartment(
        departmentId ? departmentId : response.data.default_department_id
      );
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  const fetchDepartment = async (departmentId) => {
    try {
      let newImage = departments.filter(
        (department) => department.id == departmentId
      );

      if (newImage.length > 0) {
        setBackgroundImage(`url(${newImage[0]?.background_image})`);
      }
    } catch (error) {
      // console.error('Error fetching departments:', error);
    }
  };

  const fetchMoreNestedCards = async (columnId) => {
    let userData = JSON.parse(localStorage.getItem('userDetails'));
    const offset = paginationOffsets[columnId] || 7;
    const randomString = Math.random().toString(36).substring(2, 5);
    const _URL = `${url}board/v1/board-lists/fetch-more-cards/${columnId}?&offset=${offset}&team_key=${Number(
      userData.type === 'executive' || userData.type === 'third-party-user'|| userData.type === 'ppc'
        ? selectTeamId
        : userData.team_key
    )}&cache=${randomString}`;

    try {
      const response = await axios.get(_URL, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
        },
      });
      if (response.status === 200) {
        setBoard((prevBoard) =>
          prevBoard.map((col) =>
            col.id === columnId
              ? {
                  ...col,
                  cards: _.uniqBy([...col.cards, ...response.data.cards], 'id'),
                }
              : col
          )
        );
        // Update the offset to the next set of cards to load
        setPaginationOffsets((prevOffsets) => ({
          ...prevOffsets,
          [columnId]: offset + response.data.cards_count,
        }));
      }
    } catch (err) {
      setError(err);
    }
  };
  //need to add node socket
  const handleCoverChange = (data, cardid, boardlistid) => {
    setCardDetail((prevState) => ({
      ...prevState,
      ...data, // Spread operator to merge existing state with new data
    }));

    // Update the board list
    setBoard((prevState) => {
      // Find the index of the board list that matches boardlistid
      const boardListIndex = prevState.findIndex(
        (list) => list.id === boardlistid
      );

      if (boardListIndex === -1) {
        // If the board list is not found, return the previous state unchanged
        return prevState;
      }

      // Clone the current board list to modify it
      const updatedBoardList = [...prevState];

      // Find the index of the card that matches cardid
      const cardIndex = updatedBoardList[boardListIndex].cards.findIndex(
        (card) => card.id === cardid
      );

      if (cardIndex === -1) {
        // If the card is not found, return the previous state unchanged
        return prevState;
      }

      // Update the specific card with new data
      updatedBoardList[boardListIndex].cards[cardIndex] = {
        ...updatedBoardList[boardListIndex].cards[cardIndex],
        ...data, // Merge existing card data with new data
      };

      // Return the updated board state
      return updatedBoardList;
    });
  };
  const handlecardtitleapp = (cardid, boardlistid, title) => {
    // Update the board list
    setBoard((prevState) => {
      // Find the index of the board list that matches boardlistid
      const boardListIndex = prevState.findIndex(
        (list) => list.id === boardlistid
      );

      if (boardListIndex === -1) {
        // If the board list is not found, return the previous state unchanged
        return prevState;
      }

      // Clone the current board list to modify it
      const updatedBoardList = [...prevState];

      // Find the index of the card that matches cardid
      const cardIndex = updatedBoardList[boardListIndex].cards.findIndex(
        (card) => card.id === cardid
      );

      if (cardIndex === -1) {
        // If the card is not found, return the previous state unchanged
        return prevState;
      }

      // Update the specific card with new data
      updatedBoardList[boardListIndex].cards[cardIndex] = {
        ...updatedBoardList[boardListIndex].cards[cardIndex],
        title: title, // Merge existing card data with new data
      };

      // Return the updated board state
      return updatedBoardList;
    });
  };
  const handlecarduntrash = async (cardId) => {
    try {
      const apiUrl = UTILS.API_url + 'board/v1/board-list-cards/restore';

      // Construct FormData
      const formData = new FormData();
      formData.append('task_id', cardId);

      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        toast.success(response.data.success);
        if (trashUpdate != false) {
          FirstLoad.current = 0;
        }
        setTrashUpdate((prev) => !prev);
      }
    } catch (error) {
      console.error('Error fetching board data:', error);
    }
  };

  const handleNestedCardScroll = useCallback(
    _.throttle((e, columnId) => {
      const { scrollTop } = e.target;
      if (scrollTop > lastScrollTop.current) {
        const scrollThreshold =
          e.target.scrollHeight - (e.target.clientHeight + e.target.scrollTop);

        const cardHeight = 80;
        const triggerThreshold = 8 * cardHeight;

        if (scrollThreshold <= triggerThreshold) {
          lastScrollTop.current = scrollTop;
          fetchMoreNestedCards(columnId);
        }
      }
      previousScrollTop.current = scrollTop;
    }, 300),
    [paginationOffsets]
  );

  const onDragEnd = async (result) => {
    const { source, destination, draggableId } = result;
    if (
      !destination ||
      (source.droppableId === destination.droppableId &&
        source.index === destination.index)
    ) {
      return;
    }

    const sourceColumn = board.find(
      (col) => col.id === parseInt(source.droppableId)
    );
    const destinationColumn = board.find(
      (col) => col.id === parseInt(destination.droppableId)
    );
    const sourceCards = Array.from(sourceColumn.cards);
    const [movedCard] = sourceCards.splice(source.index, 1);

    let newBoard;
    if (source.droppableId === destination.droppableId) {
      sourceCards.splice(destination.index, 0, movedCard);
      const newColumn = { ...sourceColumn, cards: sourceCards };
      newBoard = board.map((col) =>
        col.id === newColumn.id ? newColumn : col
      );
    } else {
      const destinationCards = Array.from(destinationColumn.cards);
      destinationCards.splice(destination.index, 0, movedCard);
      const newSourceColumn = { ...sourceColumn, cards: sourceCards };
      const newDestinationColumn = {
        ...destinationColumn,
        cards: destinationCards,
      };

      newBoard = board.map((col) =>
        col.id === newSourceColumn.id
          ? newSourceColumn
          : col.id === newDestinationColumn.id
          ? newDestinationColumn
          : col
      );
    }

    setBoard(newBoard);
    EmitDrag();

    const updatedDestinationColumn = newBoard.find(
      (col) => col.id === parseInt(destination.droppableId)
    );

    const nestedCardIds = updatedDestinationColumn.cards.map((card) => card.id);
    const nestedCardIdsString = nestedCardIds.join(',');

    try {
      const randomString = Math.random().toString(36).substring(2, 5);
      const mainurl = `${url}board/v1/board-list-cards/move-card?${randomString}`;
      const data = new FormData();
      data.append('board_list_id', destination.droppableId);
      data.append('task_list_ids', nestedCardIdsString);
      data.append('task_id', draggableId);
      const response = await axios.post(mainurl, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'X-CSRF-TOKEN': 'SFy5sniSD26URDuLPmBAKy1C9KocZq9mXWFk0IWA',
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.status === 200) {
        toast.success(response.data.success);
      }
    } catch (error) {
      console.error('Error updating card positions:', error);
    }
  };

  const handleShow = () => setModalShow(true);
  const handleClose = () => setModalShow(false);
  const handleonDelete = async (cardId) => {
    try {
      const apiUrl = UTILS.API_url + 'board/v1/board-list-cards/delete';

      const formData = new FormData();
      formData.append('task_id', cardId);

      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.success) {
        toast.success(response.data.success);
        if (trashUpdate != false) {
          FirstLoad.current = 0;
        }
        setTrashUpdate((prev) => !prev);
      }
    } catch (error) {
      console.error('Error fetching board data:', error);
    }
  };

  const TaskParams = new URLSearchParams(location.search);
  const getTaskId = TaskParams.get('code');
  useEffect(() => {
    if (getTaskId) {
      handleShow();
      navigate('?code=' + getTaskId);
    }
  }, []);

  useEffect(() => {
    // Function to check window width
    const checkWindowSize = () => {
      if (window.innerWidth <= 767) {
        // You can adjust the width based on your mobile breakpoint
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    // Check window size on load
    checkWindowSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkWindowSize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkWindowSize);
    };
  }, []);

  if (showModalPopup) {
    return <ModalPopup />;
  }

  const changeDepartment = (event) => {
    localStorage.setItem('departmentIdds', event.target.value);
    if (event.target.value != 0) {
      setDepartmentID(event.target.value);
      initializeData(event.target.value);
      FirstLoad.current = 1;
      setSelectedDepartment(event.target.value);
      localStorage.setItem('departmentIdds', event.target.value);
      dispatchItem(UpdateDepartment(parseInt(event.target.value)));
      if (firstChange) {
        setFirstChange(false); // Update to indicate the first call has occurred
      } else {
        setLoading(true); // Set loading to true for subsequent calls
      }
    }
  };

  const logoutFunc = () => {
    localStorage.removeItem('trelloToken');
    window.location.href = 'https://tgcrm.net/dashboard';
  };

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <section
          className="content trelloBoard"
          style={{ backgroundImage, height: '100vh', backgroundSize: 'cover' }}
        >
          <div className="body_scroll">
            <div className="block-header">
              <div className="row align-items-center">
                <div className="col-xl-3">
                  <h2>
                    Techigator Trello Board{' '}
                    <span className="md-text">(1.0.19)</span>
                  </h2>
                </div>
                <div
                  className={`col-xl-9 ${isMobile ? 'd-flex' : ''} ${
                    toggleMobile ? 'activeMob' : ''
                  }`}
                >
                  <div className="toggleMob">
                    <button
                      className="btniconFilter"
                      onClick={() => settoggleMobile(!toggleMobile)}
                    >
                      {toggleMobile ? (
                        <span className="material-symbols-outlined">close</span>
                      ) : (
                        <span className="material-symbols-outlined">
                          filter_alt
                        </span>
                      )}
                    </button>
                  </div>
                  {isMobile ? (
                    <div className="toggleMob notiMob">
                      <NotificationTrello
                        handleShow={handleShow}
                        onPressCard={(value) => {
                          setCardDetail(value);
                          navigate('?code=' + value.code);
                        }}
                        setGetParams={setGetParams}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="filterArea">
                    <div className="selectDpartment">
                      {isSearching ? (
                        <ShimmerSearch />
                      ) : (
                        <Select2
                          name="id"
                          value={Number(
                            selectedDepartment == 0
                              ? localStorage.getItem('departmentIdds')
                              : selectedDepartment
                          )}
                          onSelect={(event) => changeDepartment(event)}
                          data={departments.map((departments) => ({
                            id: departments.id,
                            text: departments.name,
                          }))}
                          options={{
                            placeholder: 'All Departments',
                            allowClear: true,
                          }}
                          required
                        />
                      )}
                    </div>
                    {userDetails?.type === 'executive' ||
                    userDetails?.type === 'pcc' ||
                    userDetails?.type === 'third-party-user' ? (
                      <div className="selectTeam">
                        {isSearching ? (
                          <ShimmerSearch />
                        ) : (
                          <Select2
                            name="team_key"
                            value={selectTeamId}
                            onSelect={(e) => HandleTeamChange(e)}
                            data={[
                              { id: 0, text: 'All Teams' },
                              ...teams.map((teams) => ({
                                id: teams.team_key,
                                text: teams.name,
                              })),
                            ]}
                            options={{
                              placeholder: 'All Teams',
                              allowClear: true,
                            }}
                            required
                          />
                        )}
                      </div>
                    ) : (
                      ''
                    )}

                    <div className="wrapSearchArea">
                      {isSearching ? (
                        <ShimmerSearch />
                      ) : (
                        <SearchTrello
                          serachBoard={searchCards}
                          setCardDetail={setCardDetail}
                          handleShow={handleShow}
                          selectTeamId={selectTeamId}
                          departmentId={departmentId}
                        />
                      )}
                    </div>
                    <div className="btn_logout">
                      <button className="btn bellBtn" onClick={logoutFunc}>
                        <span className="material-symbols-outlined">
                          power_settings_new
                        </span>
                      </button>
                    </div>
                    {isMobile ? (
                      ''
                    ) : (
                      <NotificationTrello
                        notificationCount={notificationCount}
                        handleShow={handleShow}
                        onPressCard={(value) => {
                          setCardDetail(value);
                          navigate('?code=' + value.code);
                        }}
                        setGetParams={setGetParams}
                      />
                    )}
                    <UserProfile />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section-body">
            <div className="board main-board card-wrapper" ref={scrollRef}>
              {loading ? (
                <ShimmerBoardList />
              ) : (
                <>
                  {board.map((column) => (
                    <Droppable
                      droppableId={column.id.toString()}
                      key={column.id}
                    >
                      {(provided) => (
                        <div className="listHiehgt">
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className="tasks tasks-list animated react-kanban-column"
                          >
                            <Cards column={column} />
                            <div
                              className="task-list-items"
                              onScroll={(e) =>
                                handleNestedCardScroll(e, column.id)
                              }
                            >
                              <NestedCard
                                column={column}
                                handleShow={handleShow}
                                handleDelete={handleonDelete}
                                onPressCard={(value) => {
                                  setCardDetail(value);
                                  navigate('?code=' + value.code);
                                }}
                                setGetParams={setGetParams}
                              />
                              {provided.placeholder}
                            </div>
                            <AddCard
                              client={client}
                              column={column}
                              fetchUpdateCards={fetchCards}
                              selectTeamId={
                                selectTeamId == 0
                                  ? JSON.parse(
                                      localStorage.getItem('userDetails')
                                    )?.team_key
                                  : selectTeamId
                              }
                              department={Number(
                                selectedDepartment == 0
                                  ? localStorage.getItem('departmentIdds')
                                  : selectedDepartment
                              )}
                            />
                          </div>
                        </div>
                      )}
                    </Droppable>
                  ))}
                </>
              )}
            </div>
          </div>
        </section>
      </DragDropContext>
      {departments != null && (
        <Popup
          card={cardDetail}
          modalShow={modalShow}
          colors={colors}
          handleClose={handleClose}
          fetchCards={fetchCards}
          getTaskId={getTaskId}
          client={client}
          selectTeamId={selectTeamId}
          board={board}
          handleCoverChange={handleCoverChange}
          handlecardtitleapp={handlecardtitleapp}
          handlecarduntrash={handlecarduntrash}
          team={teams}
          department={departments}
          fetchCardsForPopUp={fetchCardsForPopUp}
        />
      )}
      <ToastContainer />
    </>
  );
};

export default App;
